export default __webpack_public_path__ + "static/media/Contact-us.59460bfa.jpeg";